import { CategoriesCards } from '@/components/Shares/CategoryCards';
import { Card } from '@mantine/core';
import { stats } from './data';
export const StatsCategory: React.FC = () => {
  return <Card radius={5} bg="var(--navbar-bg-color)" mt={20}>
      <CategoriesCards items={stats} span={{
      base: 4,
      md: 2
    }} isFlex gutter={{
      base: 10,
      sm: 16
    }} />
    </Card>;
};